import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  public toggleFloatingChat: Subject<any> = new Subject<any>();
  constructor() { }
}
